export const INPUT_FIELD = {
  label: '',
  type: 'text',
  field_type: 'text',
  acceptable: [],
  required: false,
};

export const TEXT_FIELD = {
  label: '',
  type: 'text',
  field_type: 'textarea',
  acceptable: [],
  required: false,
};

export const NUMERIC_FIELD = {
  label: '',
  type: 'numeric',
  field_type: 'numeric',
  acceptable: [],
  required: false,
  decommission_trigger_value: null,
  // options: [
  // 	{
  // 		label: "",
  // 	},
  // ]
};

export const IMAGE_FIELD = {
  label: '',
  type: 'multiple_photo',
  field_type: 'multiple_photo',
  acceptable: [],
  required: false,
};

export const RADIO_FIELD = {
  label: '',
  type: 'radio',
  field_type: 'radio',
  options: [
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
};

export const RADIO_OPTION = {
  label: '',
  has_comment: false,
  acceptable: false,
};

export const SUMP_SAMPLE_FIELD = (t) => ({
  label: t('createForm.fields.sumpSample'),
  type: 'sump_sample',
  field_type: 'sump_sample',
  required: false,
});

export const SUMP_SAMPLE_WITH_NA_FIELD = (t) => ({
  label: t('createForm.fields.sumpSampleOptional'),
  type: 'sump_sample_optional',
  field_type: 'sump_sample_optional',
  required: false,
});

export const TANK_CONDITION_FIELD = (t) => ({
  label: t('createForm.fields.tankCondition'),
  type: 'radio',
  field_type: 'tank_condition',
  options: [
    {
      label: t('createForm.fields.cleaned'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notCleaned'),
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
});

export const CLEANING_STATUS_FIELD = (t) => ({
  label: t('createForm.fields.cleaningStatus'),
  type: 'radio',
  field_type: 'cleaning_status',
  options: [
    {
      label: t('createForm.fields.cleaned'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notCleaned'),
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
});

export const MICROLAB_TEST_RESULT_FIELD = (t) => ({
  label: t('createForm.fields.microlabTestResult'),
  type: 'radio',
  field_type: 'microlab_test_result',
  options: [
    {
      label: t('createForm.fields.pass'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.fail'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notUsed'),
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
});

export const CHECKBOX_FIELD = {
  label: '',
  type: 'checkbox',
  field_type: 'checkbox',
  options: [
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
};

export const CHECKBOX_OPTION = {
  label: '',
  has_comment: false,
  acceptable: false,
};

export const SELECT_FIELD = {
  label: '',
  type: 'select',
  field_type: 'select',
  options: [
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
    {
      label: '',
      has_comment: false,
      acceptable: false,
    },
  ],
  required: false,
};

export const SELECT_OPTION = {
  label: '',
  has_comment: false,
  acceptable: false,
};

export const CONDITION_CODE_FIELD = (t) => ({
  label: '',
  type: 'radio',
  field_type: 'condition_code',
  required: false,
  options: [
    {
      label: t('createForm.fields.satisfactory'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.comment'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notInService'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notApplicable'),
      has_comment: false,
      acceptable: false,
    },
    {
      label: t('createForm.fields.notUsed'),
      has_comment: false,
      acceptable: false,
    },
  ],
});
